import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import updateMediaElementOperation, {
  MediaUpdateActionName,
} from 'editor/src/store/design/operation/updateMediaElementOperation';
import getMissingFontRelinks from 'editor/src/store/fonts/utils/getMissingFontRelinks';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

const relinkMissingFontsOperation = () => (dispatch: ThunkDispatch, getState: () => RootState) => {
  const { design, fonts } = getState();
  const relinks = getMissingFontRelinks(design.designData, fonts.availableFonts, fonts.uploadedFonts);
  if (!relinks.length) {
    return;
  }

  batch(() => {
    relinks.forEach(({ elementAddress, elementUpdate }) => {
      // Not an undo step: it repairs a reference rather than editing the design, and the
      // watcher would only redo it after an undo.
      dispatch(updateMediaElementOperation(elementAddress, elementUpdate, MediaUpdateActionName.FONT_UPDATED, true));
    });
  });
};

export default relinkMissingFontsOperation;
